import { render, staticRenderFns } from "./UsuarioConsignatariaLista.vue?vue&type=template&id=70635de4&"
import script from "./UsuarioConsignatariaLista.vue?vue&type=script&lang=js&"
export * from "./UsuarioConsignatariaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports